import React from "react";
import FormTable from "./FormTable";
import { CLIENT_REGISTRATION_FORM_ID } from "../../constants/constants";

const Columns: any = [
  {
    id: "clientName",
    label: "Client Name",
    align: "left",
    minWidth: 120,
  },
  {
    id: "clientType",
    label: "Client Type",
    align: "left",
    minWidth: 120,
  },
  {
    id: "clientPhoneNumber",
    label: "Client Phone Number",
    align: "left",
    minWidth: 120,
  },
];

function ClientRegistration() {
  return (
    <div>
      <FormTable formId={CLIENT_REGISTRATION_FORM_ID} columns={Columns} />
    </div>
  );
}

export default ClientRegistration;
